import React from "react";
import { useTranslation } from "react-i18next";
import { useErroredQueriesHeal } from "./useErroredQueriesHeal";

export function ErrorView(): React.ReactElement {
  const { t } = useTranslation();

  // Quietly retry the failed queries a few times with backoff (the original
  // #566 heal, now shared via the hook), and offer a reload button for the
  // impatient/persistent cases.
  useErroredQueriesHeal();

  // Render
  return (
    <div className="w-full h-full flex flex-col gap-4 justify-center items-center text-center">
      <div>
        {t("error")}.<br />
        {t("compMisc.tryRefreshing")}
      </div>
      <button
        onClick={() => window.location.reload()}
        className="px-4 py-2 rounded-md border border-gray-400 bg-white font-semibold hover:bg-gray-50"
      >
        {t("compMisc.refreshPage")}
      </button>
    </div>
  );
}
